/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Nav_ContactInputs */

const cs_public_site_nav_contact = /** @type {(inputs: Public_Site_Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const en_public_site_nav_contact = /** @type {(inputs: Public_Site_Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Public_Site_Nav_ContactInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_nav_contact = /** @type {((inputs?: Public_Site_Nav_ContactInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Nav_ContactInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_nav_contact(inputs)
	return cs_public_site_nav_contact(inputs)
});